import { render, staticRenderFns } from "./ResourcePasswords.vue?vue&type=template&id=1a011d2c&scoped=true"
import script from "./ResourcePasswords.vue?vue&type=script&lang=js"
export * from "./ResourcePasswords.vue?vue&type=script&lang=js"
import style0 from "./ResourcePasswords.vue?vue&type=style&index=0&id=1a011d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a011d2c",
  null
  
)

export default component.exports